import { Component, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { WhitepaperspageService } from '../../whitepaperspage.service';
import { CommonModule } from '@angular/common';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-whitepaper-article-re-report',
  templateUrl: './whitepaper-article-re-report.component.html',
  styleUrls: ['./whitepaper-article-re-report.component.scss'],
  imports: [CommonModule, UrlParamsPipe],
})
export class WhitepaperArticleReReportComponent implements OnInit, OnDestroy, OnChanges {
  @Input() pageData: any;
  queryParams: any;
  constructor(
    private whitePaperspageService: WhitepaperspageService,
    private route: ActivatedRoute,
    private posthogService: PosthogService
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
    
  }

  subscriptions: Subscription[];
  reportData: any;

  ngOnInit(): void {
    // let data = this.route.snapshot.data?.['articleContent']?.[0]?.fields;
    // if (data != null) {
    //   this.reportData = {
    //     header: data.sectionTitle,
    //     cards: data.whitepapersAndReportsElements,
    //   };
    // }
  }
  ngOnChanges(): void {
    let data = this.pageData?.fields;
    if (data != null) {
      this.reportData = {
        header: data.sectionTitle,
        cards: data.whitepapersAndReportsElements,
      };
    }
  }

  onWhitepaperClick(title: string, url: string): void {
    this.posthogService.captureContentClick('whitepaper', {
      contentTitle: title,
      location: 'whitepaper_article',
      destinationUrl: url
    });
  }
}
